export * from './constants-generated';

/** The poll timeout / interval for checking the shopping bag provider ready promise availability. */
export const BASKET_PROVIDER_POLL_TIMEOUT = 250;
export const LOG_COLOR = '90c';
//# sourceMappingURL=constants.js.map